import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SaveIcon from "@mui/icons-material/Save";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import { getriskRuleList } from "../../redux/actions/riskRulesListAction";
import { getUpdateRiskList } from "../../redux/actions/updateRiskRulesAction";
import { getAdminLogout } from "../../redux/actions/adminLogoutAction";
import { IoMdSave } from "react-icons/io";
import { useHistory } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Logout from "../../components/Logout/Logout";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const RiskRule = () => {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [show, setShow] = useState(true);
	const [notificationOpen, setNotificationOpen] = useState(false);
	const [getRiskRuleStatus, setGetRiskRuleStatus] = useState(false);
	const [getRiskRuleResArray, setgetRiskRuleResArray] = useState([]);

	const [updatedRiskRuleStatus, setUpdatedRiskRuleStatus] = useState(false);
	const [updateRiskRulePopup, setUpdateRiskRulePopup] = useState("");

	const updateRiskRuleRes = useSelector(({ updateRiskRule }) => updateRiskRule);

	const updateRiskRule = () => {
		if (updatedRiskRuleStatus) {
			if (updateRiskRuleRes.data.status == "Success") {
				setUpdateRiskRulePopup(updateRiskRuleRes.data);
				setNotificationOpen(true);
				getRiskRuleListApi();
			}
			if (updateRiskRuleRes.data.status == "failed") {
				setUpdateRiskRulePopup(updateRiskRuleRes.data);
				setNotificationOpen(true);
				if (
					updateRiskRuleRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateRiskRuleRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateRiskRule();
	}, [updateRiskRuleRes.data.status]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const history = useHistory();
	const [user, setUser] = useState({
		ruleID: "",
		riskGroup: "Please Select",
		Status: "Please Select",
		ruleeStatus: "",
		editScore: "",
		editLimit: ""
	});
	const { ruleID, riskGroup, Status, ruleeStatus, editScore, editLimit } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (name == "riskGroup") {
			obj[name] = value;
		} else if (name == "Status") {
			obj[name] = value;
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "url") {
			obj[name] = Util.verifyUrl(value) ? value : obj[name];
		}
		// else {
		//   obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		// }
		setUser(obj);
	};

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getAllWalletsListRes = useSelector(
		({ riskRulesList }) => riskRulesList
	);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getRiskRuleListApi = () => {
		setIsLoading(true);
		setGetRiskRuleStatus(true);
		// setShow(false);
		const getAllWalletsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				// customerId: "",
				// customerName: "",
				// currency: "",
				// walletType: "owner",
				ruleId: ruleID,
				riskGroup: riskGroup == "Please Select" ? "" : riskGroup,
				ruleStatus: Status == "Please Select" ? "" : Status,
				customerId: ""
			}
		};

		return dispatch(getriskRuleList(getAllWalletsListReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getRiskRuleListApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getRiskRuleStatusFunc = () => {
		if (getRiskRuleStatus) {
			setIsLoading(false);
			if (getAllWalletsListRes.data.status == "Success") {
				setIsLoading(false);
				setgetRiskRuleResArray(
					[].concat(getAllWalletsListRes.data.riskRuleList)
				);
			}
			if (getAllWalletsListRes.data.status == "failed") {
				setIsLoading(false);
				setGetRiskRuleStatus(false);
				setgetRiskRuleResArray(getAllWalletsListRes.data);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// if (
				//   getAllWalletsListRes.data.result.description == "Authorization Failed"
				// ) {
				//   Logout(dispatch, history, partnerloginUser);
				// }
			}
			if (getAllWalletsListRes.data.status == "Failed") {
				setIsLoading(false);
				setGetRiskRuleStatus(false);
				setgetRiskRuleResArray(getAllWalletsListRes.data);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// getAllWalletsListRes.data.result.description
			}
		}
	};

	useEffect(() => {
		getRiskRuleStatusFunc();
	}, [getAllWalletsListRes.data.status]);

	var obj = getRiskRuleResArray;

	const getCurrIdx = (value, data) => {
		const index = obj.findIndex((d) => d.ruleId === data.ruleId);
		obj[index].ruleStatus = value;
		setgetRiskRuleResArray([]);
		setgetRiskRuleResArray([].concat(obj));
	};

	const handlefeeChargesFn = (idx, valueScore, nameScore) => {
		if (nameScore == "riskScore") {
			obj[idx].riskScore = valueScore;
			setgetRiskRuleResArray([]);
			setgetRiskRuleResArray([].concat(obj));
		}
		if (nameScore == "riskLimit") {
			obj[idx].limit = valueScore;
			setgetRiskRuleResArray([]);
			setgetRiskRuleResArray([].concat(obj));
		}
	};

	// getupdateRiskRule
	const getupdateRiskRule = () => {
		setUpdatedRiskRuleStatus(true);
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			riskRuleList: getRiskRuleResArray
		};
		return dispatch(getUpdateRiskList(Req, authToken));
	};

	useEffect(() => {
		if (getAllWalletsListRes.data.status == "Success") {
			setPage(0);
		}
	}, [getAllWalletsListRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem"
						}}
					>
						<Grid item md={8} sm={12} lg={8}></Grid>
						<Grid item md={4} sm={12} lg={4}>
							<NavLink to="/index/rule-mapping">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Rules Mapping for Merchant
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
								// onClick={getgateWayTransactionListReq}
								>
									Rules Mapping for Merchant
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								size="small"
								type="text"
								label=" Rule ID"
								fullWidth={true}
								color="primary"
								autoFocus={true}
								variant="standard"
								name="ruleID"
								value={ruleID}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "number")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Risk Group"
								fullWidth={true}
								variant="standard"

								name="riskGroup"
								// value={riskGroup}
								defaultValue={"Please Select" || riskGroup}
								onChange={(e) => onInputChange(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Please Select" selected="Please Select">
									Please Select
								</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase ">Purchase</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Status"
								fullWidth={true}
								name="Status"
								variant="standard"

								// value={Status}
								defaultValue={"Please Select" || Status}
								onChange={(e) => onInputChange(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Please Select" selected="Please Select">
									Please Select
								</MenuItem>
								<MenuItem value="Y">Enable</MenuItem>
								<MenuItem value="N">Disable</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getRiskRuleListApi}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getRiskRuleListApi}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRiskRuleStatus == false ? (
					// show
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Default Rule List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Default Rule List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule Name{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Risk Group
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Score
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getRiskRuleResArray &&
											[]
												.concat(getRiskRuleResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">{row.ruleId}</TableCell>
														<TableCell align="center">{row.ruleName}</TableCell>
														<TableCell align="center">
															{row.riskGroup}
														</TableCell>
														<TableCell align="center">
															<TextField
																type="number"
																value={row.riskScore}
																size="small"
																
																color="primary"
																autoFocus={true}
																variant="standard"
																fullWidth={true}
																onChange={({ target: { value } }) =>{
																	const newScore = parseFloat(value)
																    if(newScore >=0 || value ===''){
																	  handlefeeChargesFn(index, value, "riskScore")
																	}
																}}
															>
																{/* {row.riskScore} */}
															</TextField>
														</TableCell>
														<TableCell align="center">
															<TextField
																type="number"
																value={row.limit}
																size="small"
																color="primary"
																autoFocus={true}
																variant="standard"

																// variant="outlined"
																fullWidth={true}
																onChange={({ target: { value } }) =>{
																	const newLimit = parseFloat(value);
																	if(newLimit >=0 || value ===''){
																	handlefeeChargesFn(index, value, "riskLimit")
																	}
																}}
															>
																{/* {row.limit} */}
															</TextField>
														</TableCell>
														<TableCell align="center">
															<TextField
																select
																size="small"
																color="primary"
																autoFocus={true}
																// label="role"
																variant="standard"

																// variant="outlined"
																fullWidth={true}
																name="ruleeStatus"
																value={row.ruleStatus}
																onChange={(e) => onInputChange(e)}
															// name="role"
															// value={role}
															// onChange={(e) => onInputChange(e)}
															>
																<MenuItem
																	onClick={() => getCurrIdx("Y", row)}
																	value={"Y"}
																>
																	Enable
																</MenuItem>
																<MenuItem
																	onClick={() => getCurrIdx("N", row)}
																	value={"N"}
																>
																	Disable
																</MenuItem>
															</TextField>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>

								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={
										[].concat(getAllWalletsListRes.data.riskRuleList).length
									}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
								<Grid container>
									<Grid item md={5} lg={5}></Grid>
									<Grid item md={2} lg={2}>
										{/* <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#00b9f5",
                        color: "white",
                      }}
                      size="small"
                      className="my-2"
                      endIcon={<IoMdSave />}
                      onClick={getupdateRiskRule}
                    >
                      Save
                    </Button> */}
										<CustomButton
											style={{
												padding: "8px"
											}}
											onClick={getupdateRiskRule}
										>
											Save <SaveIcon />
										</CustomButton>
									</Grid>
									<Grid item md={5} lg={5}></Grid>
								</Grid>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{updateRiskRulePopup.status == "Success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateRiskRulePopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateRiskRulePopup.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateRiskRulePopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateRiskRulePopup.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateRiskRulePopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default RiskRule;
